import Styled from "styled-components";

export type BentoCardVariant =
  | "bottomRight"
  | "bottomLeft"
  | "bottomCenter"
  | "bottomFullWidth"
  | "centerFree"
  | "tall"
  | "wide";

export type BentoCardBackground =
  | "gradientPurple"
  | "gradientPurpleFilled"
  | "gradientPurpleOutline"
  | "gradientBlue"
  | "gradientPeach"
  | "solidPurple"
  | "solidOrange"
  | "transparent";

export type BentoCardLightMode =
  | "light"
  | "dark"
  | "darkAutodesigner"
  | "darkHomepage";

export interface ContainerProps {
  $variant: BentoCardVariant;
  $backgroundColor: BentoCardBackground;
  $cardName: string;
  $lightMode: BentoCardLightMode;
}

export const Container = Styled.div<ContainerProps>`
  position: relative;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
  width: 100%;
  border: 1px solid ${(props) => props.theme.colors.neutrals.gray200};
  border-radius: 1rem;
  overflow: hidden;
  z-index: 1;

  .gatsby-image-wrapper {
    position: relative;
    top: 1px;
    left: 1px;
  }

  ${(props) =>
    props.$backgroundColor === "transparent" &&
    `
    background: unset;
  `}

  ${(props) =>
    props.$variant === "bottomRight" &&
    `
    padding: 1.5rem 0 0 1.5rem;
  `}

  ${(props) =>
    props.$variant === "bottomLeft" &&
    `
    padding: 1.5rem 1.5rem 2.5rem 0;
  `}

  ${(props) =>
    props.$variant === "bottomCenter" &&
    `
    padding: 1.5rem 0 0 1.5rem;
  `}

  ${(props) =>
    props.$variant === "bottomFullWidth" &&
    `
    padding: 1.5rem 0 0 0;
  `}

  ${(props) =>
    props.$variant === "centerFree" &&
    `
    padding: 1.5rem 0 1.5rem 1.5rem;
  `}

  ${(props) =>
    props.$variant === "tall" &&
    `
    padding: 1.5rem 0 0 1.5rem;
  `}

  ${(props) =>
    props.$variant === "wide" &&
    `
    padding: 1.5rem 0 0 1.5rem;
  `}

  ${(props) =>
    props.$lightMode === "light" &&
    `
    ${
      props.$cardName === "card3" &&
      `
      .gatsby-image-wrapper {
        margin-bottom: 1.5rem;
      }
      `
    };
  `}

  ${(props) =>
    (props.$lightMode === "dark" ||
      props.$lightMode === "darkAutodesigner" ||
      props.$lightMode === "darkHomepage") &&
    `
    border: 1px solid ${props.theme.colors.neutrals.gray700};
    box-shadow: none;
  `}

  ${(props) => props.theme.breakpoints.up("medium")} {

    ${(props) =>
      props.$variant === "bottomRight" &&
      `
      padding: 2.5rem 0 0 2.5rem;

      .gatsby-image-wrapper {
        border-radius: 0.75rem 0 0 0 !important;
      }
    `}

    ${(props) =>
      props.$variant === "bottomLeft" &&
      `
      padding: 2.5rem 2.5rem 2.5rem 0;
    `}

    ${(props) =>
      props.$variant === "bottomCenter" &&
      `
      padding: 2.5rem 0 0 2.5rem;
    `}

    ${(props) =>
      props.$variant === "bottomFullWidth" &&
      `
      padding: 2.5rem 0 0 0;
    `}

    ${(props) =>
      props.$variant === "centerFree" &&
      `
      padding: 2.5rem 0 2.5rem 2.5rem;
    `}

    ${(props) =>
      props.$variant === "tall" &&
      `
      padding: 2.5rem 0 0 2.5rem;
    `}

    ${(props) =>
      props.$variant === "wide" &&
      `
      padding: 2.5rem 0 0 2.5rem;
      flex-direction: row;
      align-items: flex-end;
      gap: 0.5rem;
    `}

    ${(props) =>
      props.$lightMode === "light" &&
      `
      ${
        props.$cardName === "card1" &&
        `
        grid-column: 1 / span 2;
        `
      };

      ${
        props.$cardName === "card5" &&
        `
        gap: 0.5rem;
        `
      };

      ${
        props.$cardName === "card5" &&
        `
        margin-top: -2.5rem;
      `
      };
    `}

    ${(props) =>
      props.$lightMode === "dark" &&
      `
      ${
        props.$cardName === "card1" &&
        `
        grid-column: 1 / span 2;
        `
      };

      ${
        props.$cardName === "card2" &&
        `
        align-self: stretch;
        `
      };

      ${
        props.$cardName === "card4" &&
        `
        grid-column: 1 / span 2;
        `
      };
    `}

    ${(props) =>
      props.$lightMode === "darkAutodesigner" &&
      `
      ${
        props.$cardName === "card1" &&
        `
        grid-column: 1 / span 2;
        `
      };

      ${
        props.$cardName === "card2" &&
        `
        grid-column: 1 / span 1;
        align-self: stretch;
        `
      };

      ${
        props.$cardName === "card3" &&
        `
        grid-column: 2 / span 1;
        `
      };


      ${
        props.$cardName === "card4" &&
        `
        grid-column: 1 / span 1;
        align-self: stretch;
      `
      };

      ${
        props.$cardName === "card5" &&
        `
        grid-column: 2 / span 1;
      `
      };
    `}

    ${(props) =>
      props.$lightMode === "darkHomepage" &&
      `
      ${
        props.$cardName === "card1" &&
        `
        grid-column: 1 / span 1;
        align-self: stretch;
        `
      };

      ${
        props.$cardName === "card2" &&
        `
        grid-column: 2 / span 1;
        `
      };

      ${
        props.$cardName === "card3" &&
        `
        grid-column: 1 / span 1;
        align-self: stretch;
        `
      };


      ${
        props.$cardName === "card4" &&
        `
        grid-column: 2 / span 1;
        align-self: stretch;
        flex-direction: column;
      `
      };

      ${
        props.$cardName === "card5" &&
        `
        grid-column: 1 / span 1;
        align-self: stretch;
      `
      };

      ${
        props.$cardName === "card6" &&
        `
        grid-column: 2 / span 1;
      `
      };
    `}
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    align-items: flex-start;
    width: auto;
    height: 100%;

  ${(props) =>
    props.$variant === "bottomCenter" &&
    `
    padding: 2.5rem 2.5rem 0 2.5rem;

    .gatsby-image-wrapper {
      border-radius: 0.75rem 0.75rem 0 0 !important;
    }
  `}

  ${(props) =>
    props.$variant === "centerFree" &&
    `
    padding: 2.5rem 2.5rem;
  `}

  ${(props) =>
    props.$variant === "wide" &&
    `
    gap: 2rem;
  `}

  ${(props) =>
    props.$variant === "tall" &&
    `
    padding: 2.5rem 0;
  `}

  ${(props) =>
    props.$lightMode === "light" &&
    `
    ${
      props.$cardName === "card1" &&
      `
      grid-column: 1 / span 7;
      grid-row: 1 / span 1;
    `
    };

    ${
      props.$cardName === "card2" &&
      `
      grid-column: 8 / span 5;
      grid-row: 1 / span 1;
    `
    };

    ${
      props.$cardName === "card3" &&
      `
      grid-column: 1 / span 6;
      grid-row: 2 / span 1;

      .gatsby-image-wrapper {
        margin-bottom: 0;
      }
    `
    };

    ${
      props.$cardName === "card4" &&
      `
      grid-column: 1 / span 6;
      grid-row: 3 / span 1;
    `
    };

    ${
      props.$cardName === "card5" &&
      `
      margin-top: 0;
      grid-column: 7 / span 6;
      grid-row: 2 / span 2;
      gap: 2rem;
      `
    };
  `}

  ${(props) =>
    props.$lightMode === "dark" &&
    `
    ${
      props.$cardName === "card1" &&
      `
      grid-column: 1 / span 7;
      grid-row: 1 / span 1;
    `
    };

    ${
      props.$cardName === "card2" &&
      `
      grid-column: 8 / span 5;
      grid-row: 1 / span 1;
    `
    };

    ${
      props.$cardName === "card3" &&
      `
      grid-column: 1 / span 4;
      grid-row: 2 / span 2;
    `
    };

    ${
      props.$cardName === "card4" &&
      `
      grid-column: 5 / span 8;
      grid-row: 2 / span 1;
      align-items: flex-end;
    `
    };

    ${
      props.$cardName === "card5" &&
      `
      grid-column: 5 / span 4;
      grid-row: 3 / span 1;
    `
    };

    ${
      props.$cardName === "card6" &&
      `
      align-self: auto;
      grid-column: 9 / span 4;
      grid-row: 3 / span 1;
    `
    };

    ${
      props.$cardName === "card7" &&
      `
      grid-column: 1 / span 6;
      grid-row: 4 / span 1;
    `
    };

    ${
      props.$cardName === "card8" &&
      `
      grid-column: 7 / span 6;
      grid-row: 4 / span 1;
    `
    };
  `}

   ${(props) =>
     props.$lightMode === "darkAutodesigner" &&
     `
    ${
      props.$cardName === "card1" &&
      `
      grid-column: 1 / span 12;
      grid-row: 1 / span 1;
      align-items: flex-end;

      .gatsby-image-wrapper {
        width: 83% !important;
      }
    `
    };

    ${
      props.$cardName === "card2" &&
      `
      grid-column: 1 / span 7;
      grid-row: 2 / span 1;
    `
    };

    ${
      props.$cardName === "card3" &&
      `
      grid-column: 8 / span 5;
      grid-row: 2 / span 1;
    `
    };

    ${
      props.$cardName === "card4" &&
      `
      grid-column: 1 / span 6;
      grid-row: 3 / span 1;
      align-items: flex-end;
      padding-bottom: 4rem;
    `
    };

    ${
      props.$cardName === "card5" &&
      `
      grid-column: 7 / span 6;
      grid-row: 3 / span 1;
    `
    };
  `}

     ${(props) =>
       props.$lightMode === "darkHomepage" &&
       `
    ${
      props.$cardName === "card1" &&
      `
      grid-column: 1 / span 7;
      grid-row: 1 / span 1;
    `
    };

    ${
      props.$cardName === "card2" &&
      `
      grid-column: 8 / span 5;
      grid-row: 1 / span 1;
    `
    };

    ${
      props.$cardName === "card3" &&
      `
      grid-column: 1 / span 5;
      grid-row: 2 / span 1;
    `
    };

    ${
      props.$cardName === "card4" &&
      `
      grid-column: 6 / span 7;
      grid-row: 2 / span 1;
      align-items: flex-end;
      flex-direction: row;
    `
    };

    ${
      props.$cardName === "card5" &&
      `
      grid-column: 1 / span 6;
      grid-row: 3 / span 1;
    `
    };

    ${
      props.$cardName === "card6" &&
      `
      grid-column: 7 / span 6;
      grid-row: 3 / span 1;
    `
    };
  `}
  }
`;

export interface MessageProps {
  $backgroundColor: BentoCardBackground;
  $textColor: string;
  $cardName: string;
  $lightMode: BentoCardLightMode;
  $variant: BentoCardVariant;
}

export const Message = Styled.div<MessageProps>`
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  justify-content: center;
  gap: 0.75rem;
  padding: 0 1.5rem 0 0;

  color: ${(props) => (props.$textColor === "light" ? "#030303" : "#FFF")};

  ${(props) =>
    (props.$backgroundColor === "solidPurple" ||
      props.$backgroundColor === "solidOrange") &&
    `
    color: #FFF;
  `}

  ${(props) =>
    props.$variant === "centerFree" &&
    `
    padding: 0 2.5rem 0 0;
  `}

  ${(props) =>
    props.$variant === "bottomLeft" &&
    `
    padding: 0 1.5rem 0 1.5rem;
  `}

  ${(props) =>
    props.$variant === "bottomFullWidth" &&
    `
    padding: 0 1.5rem 0 1.5rem;
  `}

  ${(props) =>
    props.$lightMode === "dark" &&
    `
      ${
        props.$cardName === "card7" &&
        `
        padding: 0 3.5rem 0 0;
      `
      };
  `}

  ${(props) => props.theme.breakpoints.up("medium")} {
    gap: 1.5rem;

    ${(props) =>
      props.$variant === "bottomLeft" &&
      `
      padding: 0 1.5rem 0 2.5rem;
    `};

    ${(props) =>
      props.$variant === "bottomFullWidth" &&
      `
      padding: 0 1.5rem 0 2.5rem;
    `}

    ${(props) =>
      props.$variant === "wide" &&
      `
      padding: 0;
      width: 100%;
    `};
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    ${(props) =>
      props.$variant === "tall" &&
      `
      padding: 0 2.5rem 0 2.5rem;
    `}

    ${(props) =>
      props.$variant === "wide" &&
      `
      width: auto;
      height: 100%;
      display: block;
    `}

    ${(props) =>
      props.$variant === "bottomFullWidth" &&
      `
      padding: 0 2.5rem 0 2.5rem;
    `}

    ${(props) =>
      props.$lightMode === "dark" &&
      `
      ${
        props.$cardName === "card5" &&
        `
        padding: 0 1rem 0 2.5rem;
      `
      };

      ${
        props.$cardName === "card6" &&
        `
        padding: 0 1rem 0 0;
      `
      };
    `}

    ${(props) =>
      props.$lightMode === "darkAutodesigner" &&
      `
      ${
        props.$cardName === "card1" &&
        `
        .gatsby-image-wrapper {
          width: auto !important;
        }
      `
      };

      ${
        props.$cardName === "card3" &&
        `
        padding: 0;
      `
      };
    `}

    ${(props) =>
      props.$lightMode === "darkHomepage" &&
      `
      ${
        props.$cardName === "card2" &&
        `
        padding-right: 0;
      `
      };
    `}

  }
`;

export interface DescriptionWrapperProps {
  $background: string;
  $lightMode: BentoCardLightMode;
}

export const DescriptionWrapper = Styled.div<DescriptionWrapperProps>`
  p {
    font-weight: 560;
  }

  ${(props) =>
    (props.$background === "solidPurple" ||
      props.$background === "solidOrange") &&
    `
    p {
      color: #FFF;
    }
  `}

  ${(props) =>
    (props.$lightMode === "dark" || props.$lightMode === "darkAutodesigner") &&
    `
    p {
      color: #FFF;
    }
  `}
`;

export interface IllustrationContainerProps {
  $cardName?: string;
  $lightMode?: BentoCardLightMode;
  $addGradient?: boolean;
}

export const IllustrationContainer = Styled.div<IllustrationContainerProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  .gatsby-image-wrapper {
    border-radius: 0.375rem 0 0 0.375rem;
    box-shadow: 0px 12px 30px -4px rgba(3, 3, 3, 0.12);

    ${(props) =>
      props.$addGradient &&
      `
      -webkit-mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 45%, rgb(0, 0, 0) 50%, rgb(0, 0, 0) 55%, rgba(0, 0, 0, 0) 100%);
      mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgb(0, 0, 0) 45%, rgb(0, 0, 0) 50%, rgb(0, 0, 0) 55%, rgba(0, 0, 0, 0) 100%);
    `}
  }

    ${(props) => props.theme.breakpoints.up("medium")} {

    ${(props) =>
      props.$lightMode === "darkAutodesigner" &&
      `
      ${
        props.$cardName === "card2" &&
        `
        .gatsby-image-wrapper {
          min-height: 76%;
          border-radius: 0.75rem 0 0 1.5rem !important;
        };

       img  {
          object-position: 0% 0%;
        }
        `
      };
    `}

    ${(props) =>
      props.$lightMode === "darkHomepage" &&
      `
      ${
        props.$cardName === "card1" &&
        `
        .gatsby-image-wrapper {
          min-height: 76%;
          border-radius: 0.75rem 0 0 1.25rem !important;
        };

       img  {
          object-position: 0% 0%;
        }
      `
      };

      ${
        props.$cardName === "card2" &&
        `
        .gatsby-image-wrapper {
          border-radius: 0.75rem;
        };
      `
      };

      ${
        props.$cardName === "card4" &&
        `
        margin-top: 1rem;
      `
      };


      ${
        props.$cardName === "card5" &&
        `
        align-items: flex-end;
      `
      };

      ${
        props.$cardName === "card6" &&
        `
        .gatsby-image-wrapper {
          max-width: 67%;
        }
      `
      };
    `}
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    width: auto;
    height: auto;

    .gatsby-image-wrapper {
      border-radius: 0.75rem 0 0;
      width: auto;
      height: auto;
    }

    ${(props) =>
      props.$lightMode === "dark" &&
      `
      ${
        props.$cardName === "card7" &&
        `
        .gatsby-image-wrapper {
          max-width: 24.25rem;
        };
        `
      };
    `}

    ${(props) =>
      props.$lightMode === "darkHomepage" &&
      `
      ${
        props.$cardName === "card2" &&
        `
        .gatsby-image-wrapper {
          max-width: 25.5rem;
          border-radius: 0.75rem 0 0;
        };
        `
      };
    `}

    ${(props) =>
      props.$lightMode === "darkAutodesigner" &&
      `
      ${
        props.$cardName === "card3" &&
        `
        .gatsby-image-wrapper {
          max-width: 25.5rem;
          border-radius: 0.75rem;
        };
        `
      };

      ${
        props.$cardName === "card5" &&
        `
        .gatsby-image-wrapper {
          max-width: 32.5rem;
        };
        `
      };
    `}
  }
`;

export const BackgroundImageContainer = Styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  position: relative;
  z-index: -1;

  svg {
    width: 100%;
  }
`;

export const BackgroundSolidColorPurple = Styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  background: linear-gradient(107deg, #793CFB 0%, #6419FF 100%), #FFF;
`;

export const BackgroundSolidColorOrange = Styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  background: linear-gradient(107deg, #FF8133 0%, #FE6601 100%);
`;

export const BackgroundImagePurpleFilled = Styled.img`
  width: 1374px;
  height: 773px;
  position: absolute;
  right: -625px;
  bottom: -211px;

  ${(props) => props.theme.breakpoints.up("medium")} {
    left: -414px;
    bottom: -171px;
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    left: -414px;
    top: -162px;
  }
`;

export interface BackgroundImagePurpleOutlineProps {
  $lightMode?: BentoCardLightMode;
}

export const BackgroundImagePurpleOutline = Styled.img<BackgroundImagePurpleOutlineProps>`
  width: 1789.382px;
  height: 1006.527px;
  position: absolute;
  left: -909px;
  top: -561px;

  ${(props) => props.theme.breakpoints.up("medium")} {
    left: -892px;
    top: -526px;

    ${(props) =>
      props.$lightMode === "darkHomepage" &&
      `
      top: -498px;
    `}
  }

  ${(props) => props.theme.breakpoints.up("large")} {
    left: -840px;
    top: -603px;
    height: 1020px;
  }
`;
